import { createStyles, rem } from "@mantine/core"
import { CONTAINER_ANIMATION_DURATION, ICON_ANIMATION_DURATION } from "./CampaignTypeSelect.constants"

interface CampaignSelectStyleProps {
    isExpanded: boolean
}

export const useStyles = createStyles((theme, { isExpanded }: CampaignSelectStyleProps) => ({
    frame: {
        display: "grid",
        padding: `${theme.spacing.xs} 0`,
        alignSelf: "stretch",
        flexWrap: "wrap",

        gap: theme.spacing.xl,

        [theme.fn.largerThan("md")]: {
            gridTemplateColumns: "1fr 1fr 1fr 1fr",
        },
        [theme.fn.smallerThan("md")]: {
            gridTemplateColumns: "1fr 1fr 1fr",
        },
        [theme.fn.smallerThan("sm")]: {
            gridTemplateColumns: "1fr 1fr",
        },

        transition: `all ${CONTAINER_ANIMATION_DURATION}ms linear`,
        transitionDelay: `${ICON_ANIMATION_DURATION}ms`, // Wait icon rotation
    },

    moreOptionsButton: {
        color: theme.colors.gray[7],
        fontSize: "0.875rem",
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "0.875rem",
        padding: "0.5rem 0",
    },

    moreOptionsIcon: {
        width: "0.75rem",
        height: "0.75rem",
        fontSize: `${rem(12)} !important`,
        color: theme.colors.gray[7],

        transform: isExpanded ? "rotate(180deg)" : "",

        transition: `transform ${ICON_ANIMATION_DURATION}ms`,
    },
}))
